$(function () {

  
  $(".locaton-site-inner").on("click", function () {
    $(this).parent().toggleClass('active');
  });

  $(".header-group-search .predictive-search__reset-button").on("click", function () {
    $(".predictive-search-form__content-wrapper").removeClass('active');
  });

  $(".image-text-tabs__heading").on("click", function () {
    const $parent = $(this).closest(".image-text-tabs-content");
    const index = $(this).data("index");

    $(".image-text-tabs__heading").removeClass("active");
    $(this).addClass("active");

    $parent.find(".image-text-tabs__block").hide();
    $parent.find(".image-text-tabs__block-" + index).show();
  });

  $(".collection-tabs-heading").on("click", function (event) {
    event.preventDefault()
    let index = $(this).data('index');
    $(this).siblings(".collection-tabs-heading").removeClass("active");
    $(this).addClass("active");
    $(this).parents('.section').find('.cls-collection-tab').hide();
    $(this).parents('.section').find(".cls-collection-tab-"+index).show();
  });

  $(".items-card-tab-heading-card").on("click", function (event) {
    event.preventDefault()
    let item = $(this).data('item');
    $(this).siblings(".items-card-tab-heading-card").removeClass("active");
    $(this).addClass("active");
    $(this).parents('.items-card-tabs-content').find('.items-card-tabs__blocks').hide();
    $(this).parents('.items-card-tabs-content').find('.items-card-tabs__blockss').hide();
    $(".items-card-tabs__blocks-"+item).show().slick('refresh');
    $(".items-card-tabs__blockss-"+item).show().slick('refresh');
  });

  $(".items-card-tab-heading-book").on("click", function (event) {
    event.preventDefault();
    let item = $(this).data("item");

    let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?tab=" + item;
    window.history.pushState({ tab: item }, "", newUrl);

    $(this).siblings(".items-card-tab-heading-book").removeClass("active");
    $(this).addClass("active");

    // ẩn/hiện block
    $(this).parents(".items-card-tabs-content").find(".items-card-tabs__blocks").hide();
    $(this).parents(".items-card-tabs-content").find(".items-card-tabs__blockss").hide();
    $(".items-card-tabs__blocks-" + item).show();
    $(".items-card-tabs__blockss-" + item).show();
  });

  $(document).ready(function () {
    let params = new URLSearchParams(window.location.search);
    let tab = params.get("tab");
    let box = params.get("box");

    if (tab) {
      $(".items-card-tab-heading-book[data-item='" + tab + "']")
        .addClass("active")
        .siblings(".items-card-tab-heading-book").removeClass("active");

      $(".items-card-tabs__blocks, .items-card-tabs__blockss").hide();
      $(".items-card-tabs__blocks-" + tab).show();
      $(".items-card-tabs__blockss-" + tab).show();
    }

    if (box) {
      let target = $("#" + box);
      if (target.length) {
        target.addClass("active");

        $("html, body").animate({
          scrollTop: target.offset().top - 100
        }, 600);
      }
    }
  });


  $(".collapsibles_tab .product__accordion-heading").click(function () {
    const $parent = $(this).closest(".collapsibles_tab");
    const $content = $parent.find(".accordion__contents");

    $(".collapsibles_tab").not($parent).removeClass("active")
      .find(".accordion__contents").slideUp();

    if ($parent.hasClass("active")) {
      $parent.removeClass("active");
      $content.slideUp();
    } else {
      $parent.addClass("active");
      $content.slideDown();
    }
  });

  $("footer .menu__heading").click(function () {
    const $heading = $(this);
    const $content = $heading.next(".details-content");

    $(".details-content").not($content).slideUp();
    $(".menu__heading").not($heading).removeClass("active");

    if ($heading.hasClass("active")) {
      $heading.removeClass("active");
      $content.slideUp();
    } else {
      $heading.addClass("active");
      $content.slideDown();
    }
  });

  
});

$(document).on('input', '.header-group-search .search-input', function() {
  if ($(this).val().trim() !== '') {
    $('.predictive-search-form__content-wrapper').addClass('active');
  } else {
    $('.predictive-search-form__content-wrapper').removeClass('active');
  }
});

$(document)
  .off("click", ".cls-filter-by-concern")
  .on("click", ".cls-filter-by-concern", function () {
    let $content = $(this).parent().find(".image-text-tabs-left");

    $(this).toggleClass("active");
    $content.slideToggle();
  });


  document.addEventListener("DOMContentLoaded", function () {
    const counters = document.querySelectorAll(".animation-number .cls-text-heading");

    const animateNumber = (el, target, formatFn) => {
        const duration = 2000;
        const startTime = performance.now();

        const step = (currentTime) => {
            const progress = Math.min((currentTime - startTime) / duration, 1);
            const value = progress * target;

            el.textContent = formatFn(value);

            if (progress < 1) {
                requestAnimationFrame(step);
            } else {
                el.textContent = formatFn(target); // đảm bảo kết thúc chính xác
            }
        };

        requestAnimationFrame(step);
    };

    const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const el = entry.target;
                const raw = el.textContent.trim();
                const match = raw.match(/^([\d.]+)([a-zA-Z%+]+)?$/);

                if (!match) return;

                let num = parseFloat(match[1]);
                let suffix = match[2] || "";
                let target = num;
                let formatFn;

                suffix = suffix.toUpperCase();

                if (suffix === "K+" || suffix === "K") {
                    target = num * 1000;
                    formatFn = (val) => Math.floor(val / 1000) + "K+";
                } else if (suffix === "M+" || suffix === "M") {
                    target = num * 1000000;
                    formatFn = (val) => Math.floor(val / 1000000) + "M+";
                } else if (suffix === "%") {
                    formatFn = (val) => Math.floor(val) + "%";
                } else if (suffix === "X") {
                    formatFn = (val) => val.toFixed(1) + "X";
                } else {
                    formatFn = (val) => Math.floor(val) + suffix;
                }

                animateNumber(el, target, formatFn);
                obs.unobserve(el);
            }
        });
    }, { threshold: 0.4 });

    counters.forEach((counter) => observer.observe(counter));
});
